<template>
  <div class="col-sm-12 nopads">
    <div class="search-form px-3">
      <div class="col-sm-12 search-form-title">
        <font-awesome-icon icon="search" />
        {{ $t('common.search') }}
      </div>
      <form
        class="mt-2"
        @submit.prevent="onSubmit"
        @reset="onReset"
      >
        <div class="row">
          <div class="col-sm-4">
            <span class="search-title">{{ $t('subcontractors.customer') }}</span>
              <select
                  v-model="customer"
                  class="form-select form-select-sm"
                  :disabled="!!loading"
              >
                  <option :value="null" disabled>
                      {{ $t('subcontractors.select_customer') }}
                  </option>
                  <option
                      v-for="customer in customers"
                      :key="customer.id"
                      :value="customer.id"
                  >
                      {{ customer.name }}
                  </option>
              </select>
          </div>
          <div class="col-sm-4">
            <span class="search-title">{{ $t('subcontractors.contractor') }}</span>
              <select
                  v-model="contractor"
                  class="form-select form-select-sm"
                  :disabled="!!loading"
              >
                  <option :value="null" disabled>
                      {{ $t('subcontractors.select_contractor') }}
                  </option>
                  <option
                      v-for="contractor in contractors"
                      :key="contractor.id"
                      :value="contractor.id"
                  >
                      {{ contractor.name }}
                  </option>
              </select>
          </div>
          <div class="col-sm-4">
            <span class="search-title">{{ $t('subcontractors.name') }}</span>
              <input
                  type="text"
                  v-model="subcontractorName"
                  :placeholder="$t('subcontractors.name')"
                  class="form-control form-control-sm"
                  :disabled="!!loading"
              />
          </div>
        </div>
        <div class="col-sm-12 button-container">
          <button
            type="reset"
            class="btn btn-danger form-button"
          >
            {{ $t('delivery_note.clear') }}
          </button>
          <button
            type="submit"
            class="btn btn-primary form-button"
          >
            {{ $t('common.search') }}
          </button>
        </div>
      </form>
    </div>
    <div
      v-if="!!loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from "@/components/mixins/RestApiMixin";
import {timeUtils} from "@/components/mixins/TimeUtils";

export default {
    name: "ApplicationSearch",
    mixins: [restApi, timeUtils],
    data: function () {
        return {
            contractor: null,
            customer: null,
            subcontractorName: null,
            customers: [],
            contractors: [],
            loading: 0
        }
    },
    mounted() {
        this.fetchContractors()
        this.fetchCustomers()
    },
    methods: {
        fetchCustomers: function () {
            this.loading++
            this.vehicleOptions = []
            this.restFetch(this.customerUrl, this.handleCustomers)
        },
        handleCustomers: function (response) {
            if (response && response.data) {
                this.customers = response.data
            }
            this.loading--
        },
        fetchContractors: function () {
            this.loading++
            this.vehicleOptions = []
            this.restFetch(this.contractorUrl, this.handleContractors)
        },
        handleContractors: function (response) {
            if (response && response.data) {
                this.contractors = response.data
            }
            this.loading--
        },
        onSubmit: function () {
            this.$emit('search', {customer: this.customer, contractor: this.contractor, subcontractorName: this.subcontractorName})
        },
        onReset: function () {
            this.customer = null
            this.contractor = null
            this.subcontractorName = null
        }
    }
}
</script>
